import { isProd } from '@app/api/axios';

/* Переключатель состояний доступен везде, кроме продакшена.
   Прод определяется так же, как в axios.js — по домену app.moneta.ad,
   поэтому на localhost и на стейдже панель работает, на проде её нет. */
export const DEV_TOOLS_ENABLED = !isProd;

export const DEV_OVERRIDES_STORAGE_KEY = 'dev:user-overrides';

export const DEV_NO_OVERRIDE = '__api__';

export const DEV_USER_STATES = [
  {
    field: 'group_role',
    label: 'Роль',
    short: 'Роль',
    options: [
      { label: 'Administrator', short: 'Admin', value: null },
      { label: 'Team lead', short: 'Lead', value: 1 },
      { label: 'Team member', short: 'Member', value: 2 },
    ],
  },
  {
    field: 'is_onboarding',
    label: 'Верификация',
    short: 'Вериф.',
    options: [
      { label: 'Не пройдена', short: 'нет', value: 0 },
      { label: 'На проверке', short: 'на проверке', value: 2 },
      { label: 'Пройдена', short: 'пройдена', value: 1 },
    ],
  },
  {
    field: 'is_frozen',
    label: 'Заморозка пользователя',
    short: 'Заморозка',
    options: [
      { label: 'Нет', short: 'нет', value: 0 },
      { label: 'Пользователь', short: 'да', value: 1 },
    ],
  },
  {
    field: 'isFrozenGroup',
    label: 'Команда заморожена',
    short: 'Команда',
    options: [
      { label: 'Нет', short: 'нет', value: false },
      { label: 'Да', short: 'да', value: true },
    ],
  },
  {
    field: 'two_fa',
    label: '2FA',
    short: '2FA',
    options: [
      { label: 'Выключена', short: 'выкл', value: false },
      { label: 'Включена', short: 'вкл', value: true },
    ],
  },
];

export const DEV_STATE_FIELDS = DEV_USER_STATES.map((item) => item.field);

export const readDevOverrides = () => {
  if (!DEV_TOOLS_ENABLED) return {};
  try {
    const raw = localStorage.getItem(DEV_OVERRIDES_STORAGE_KEY);
    const saved = raw ? JSON.parse(raw) : {};
    return Object.fromEntries(
      Object.entries(saved).filter(([key]) => DEV_STATE_FIELDS.includes(key)),
    );
  } catch {
    return {};
  }
};

export const writeDevOverrides = (overrides) => {
  if (!DEV_TOOLS_ENABLED) return;
  try {
    localStorage.setItem(
      DEV_OVERRIDES_STORAGE_KEY,
      JSON.stringify(overrides ?? {}),
    );
  } catch {
    /* приватный режим — переживём без сохранения */
  }
};
